import moment from 'moment';
import { getDynamicAppConfigs } from '@javascript/habitual-analytics/constants/dynamicAppConfigs';
import {
  OrderTypes,
  ProductTypes,
  TransactionType, OrderStatus,
} from '@javascript/habitual-analytics/brokers/OrderFacade/types/common';
import {
  InstaStatus,
  LocalOrderType, DefaultOrderType
} from '@javascript/habitual-analytics/brokers/OrderFacade/types/insta';
import { InstrumentModel } from '@javascript/habitual-analytics/models/instrument/types';
import { GetDynamicAppConfigs } from '@javascript/habitual-analytics/constants/types';
import { TransactionTypes } from '@javascript/habitual-analytics/domains';

export const sanitizeAndParseOrderStatus = (status: OrderStatus): InstaStatus => {
  switch (status) {
    case 'CANCELLED':
      return InstaStatus.CANCELLED;
    case 'TRADED':
      return InstaStatus.TRADED;
    case 'FAILED':
      return InstaStatus.FAILED;
    case 'EXPIRED':
      return InstaStatus.EXPIRED;
    default:
      return InstaStatus.PENDING;
  }
};

export const sanitizeParseOrderType = (orderType: OrderTypes): DefaultOrderType => {
  switch (orderType) {
    case 'LIMIT':
      return DefaultOrderType.LIMIT;
    case 'SL_M':
      return DefaultOrderType.SL_M;
    case 'SL_L':
      return DefaultOrderType.SL_L;
    default:
      return DefaultOrderType.MARKET;
  }
};

export const sanitizeProductType = (
  rawProductCode: ProductTypes,
  tradingSymbolObj: InstrumentModel
): ProductTypes => {

  if (tradingSymbolObj?.isEquity() && rawProductCode === ProductTypes.NRML)
    return ProductTypes.CNC;
  return rawProductCode === 'MIS' ? ProductTypes.MIS : ProductTypes.NRML;
};

export const sanitizeDefaultOrderType = (orderType: OrderTypes): LocalOrderType => {
  switch (orderType) {
    case 'LIMIT':
      return LocalOrderType.LIMIT;
    case 'SL_M':
      return LocalOrderType.SL_M;
    case 'SL_L':
      return LocalOrderType.SL_L;
    default:
      return LocalOrderType.MARKET;
  }
};

export const sanitizeTransActionType = (type: TransactionType): TransactionTypes => {
  return type === 'BUY' ? TransactionTypes.BUY : TransactionTypes.SELL;
};

export const formatUTCToIST = (utcTime: Date): string => {
  const { envs: { IS_DEV_MODE } }: GetDynamicAppConfigs = getDynamicAppConfigs();
  // TODO:Get common format from backend
  return IS_DEV_MODE === 'true'
    ? moment(utcTime).add(5, 'hours').add(30, 'minutes').format('YYYY-MMM-DD HH:mm:ss')
    : moment(utcTime).format('YYYY-MMM-DD HH:mm:ss');
};
